export const lockoutTypes = {
    ADD: 'lOCKOUT_ADD',
    CONNECT: 'lOCKOUT_CONNECT',
    REMOVE: 'lOCKOUT_REMOVE',
    SET: 'lOCKOUT_SET',
    STOP: 'lOCKOUT_STOP',
}
